export const HIGHLIGHT_COLORS = [
  { id: "gold", label: "Gold", swatch: "hsl(45 90% 52%)", bg: "hsl(45 90% 60% / 0.35)" },
  { id: "sage", label: "Sage", swatch: "hsl(140 35% 45%)", bg: "hsl(140 40% 55% / 0.3)" },
  { id: "rose", label: "Rose", swatch: "hsl(345 60% 58%)", bg: "hsl(345 70% 65% / 0.28)" },
  { id: "sky", label: "Sky", swatch: "hsl(205 70% 50%)", bg: "hsl(205 75% 60% / 0.3)" },
];

export const highlightBg = (id) => HIGHLIGHT_COLORS.find((c) => c.id === id)?.bg;
export const highlightSwatch = (id) => HIGHLIGHT_COLORS.find((c) => c.id === id)?.swatch;
